__webpack_require__.p = "/culinary-recipes/";